import { useState } from 'react';
import styles from './app-item.module.scss';
import { OpenExternalSvg } from '../../icons/open-external.svg';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getVisualCharacterCount } from '../../utils/appUtils';
import { useCleanIsActiveUrl } from '@spins-gcp/shared-components-react';
import { AppNavItem } from '../../utils/interfaces';

export function AppItemWithoutDropdown({
  path,
  abbreviation,
  pageName,
}: AppNavItem) {
  const [showExternal, setShowExternal] = useState(false);

  const { isActive, href, shouldOpenNewTab } = useCleanIsActiveUrl(path ?? '#');
  const abbreviationVisualCount = getVisualCharacterCount(abbreviation ?? '');

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement="auto"
      overlay={
        pageName && pageName.length > 23 ? <Tooltip>{pageName}</Tooltip> : <></>
      }
    >
      <button
        onClick={() => window.open(href, shouldOpenNewTab ? '_blank' : '_self')}
        className={`${styles['app-item']} ${isActive ? styles['active'] : ''}`}
        data-testid={'app-item-button'}
        onMouseEnter={() => {
          if (shouldOpenNewTab) {
            setShowExternal(true);
          }
        }}
        onMouseLeave={() => setShowExternal(false)}
      >
        <span
          className={
            abbreviationVisualCount > 3
              ? `${styles['icon']} ${styles['small-font']}`
              : styles['icon']
          }
        >
          {abbreviation}
        </span>
        <span className={styles['name']}>{pageName}</span>
        {showExternal && <OpenExternalSvg color={'rgba(21, 22, 26, 0.55)'} />}
      </button>
    </OverlayTrigger>
  );
}
